module.exports = __webpack_public_path__ + "check-tenant@2x.2bf457cd0d090a6567048fa66bd30592.png";